export default __webpack_public_path__ + "images/trial04.svg";